import { getV3Authorizer } from './authorizer.js';
import { getAuthHeadersGetter } from './getAuthHeadersGetter.js';
import { getPlaybackSources } from './getPlaybackSources.js';
import '@dtvgo/utils';
import '@dtvgo/backend-service';
import '@dtvgo/player-common-utils';

async function getPlaybackInfoWithAuthorizerV3(backendService, {
  isLive,
  contentId,
  getDelay,
  getIsMobileNetwork
}, options) {
  const {
    data: {
      authorization,
      refreshToken,
      drmId,
      drms,
      manifest,
      ...rest
    }
  } = await backendService.entitlement.v3.getTokenAuthorizer({
    delay: getDelay?.() || 0,
    mobileNetwork: getIsMobileNetwork?.() || false,
    isLive,
    contentId
  });
  const issuedAt = Date.now();
  const authorizer = getV3Authorizer(backendService, {
    isLive,
    contentId,
    getDelay,
    getIsMobileNetwork
  });
  const {
    getAuthHeaders,
    clearRefreshTimeout
  } = getAuthHeadersGetter({
    initialData: { accessToken: authorization, refreshToken, issuedAt },
    authorizer,
    onError: options.onAuthorizerError,
    refreshSecondsBefore: options.refreshSecondsBefore
  });
  const sources = getPlaybackSources({
    playbackInfo: {
      drmId,
      drms,
      manifest
    },
    getAuthHeaders
  });
  return {
    ...rest,
    sources,
    clearRefreshTimeout
  };
}

export { getPlaybackInfoWithAuthorizerV3 };
//# sourceMappingURL=getPlaybackInfo.js.map
